export default __webpack_public_path__ + "static/media/teacher_schedule_tablet.bea8cbff.jpg";